const dmGen = `<radio 
label="dmGen">
<title>Are you...?</title>
<alt>Gender</alt>
<row label="r1" value="1">Male</row>
<row label="r2" value="2">Female</row>
<row label="r3" value="3" where="none">Transgender</row>
<row label="r4" value="4">Non-binary or Gender Non-conforming</row>
<row label="r9" value="9">Prefer not to answer</row>
</radio>
`;

const dmAge = `<number 
label="dmAge"
fwidth="3"
optional="0"
size="3"
verify="range(0,120)">
<title>What is your age?</title>
<alt>Age</alt>
</number>
`;

const netAge = `<radio 
label="netAge"
translateable="0"
where="execute,survey,report">
<title>Age (Net)</title>
<exec>
if dmAge.check('18-24'): thisQuestion.val = thisQuestion.r1.index
elif dmAge.check('25-34'): thisQuestion.val = thisQuestion.r2.index
elif dmAge.check('35-44'): thisQuestion.val = thisQuestion.r3.index
elif dmAge.check('45-54'): thisQuestion.val = thisQuestion.r4.index
elif dmAge.check('55-64'): thisQuestion.val = thisQuestion.r5.index
elif dmAge.check('&gt;=65'): thisQuestion.val = thisQuestion.r6.index
</exec>

<row label="r1">18-24</row>
<row label="r2">25-34</row>
<row label="r3">35-44</row>
<row label="r4">45-54</row>
<row label="r5">55-64</row>
<row label="r6">65+</row>
</radio>
`;

const dmLoc = `<select label="dmLoc">
<title>In what country or region do you currently reside?</title>
<choice label="ch244" value="244">United States</choice>
<choice label="ch1" value="1">Afghanistan</choice>
<choice label="ch2" value="2">Albania</choice>
<choice label="ch3" value="3">Algeria</choice>
<choice label="ch4" value="4">American Samoa (U.S)</choice>
<choice label="ch5" value="5">Andorra</choice>
<choice label="ch6" value="6">Angola</choice>
<choice label="ch7" value="7">Anguilla</choice>
<choice label="ch8" value="8">Antarctica</choice>
<choice label="ch9" value="9">Antigua and Barbuda</choice>
<choice label="ch10" value="10">Argentina</choice>
<choice label="ch11" value="11">Armenia</choice>
<choice label="ch12" value="12">Aruba</choice>
<choice label="ch13" value="13">Ascension Island</choice>
<choice label="ch14" value="14">Australia</choice>
<choice label="ch15" value="15">Austria</choice>
<choice label="ch16" value="16">Azerbaijan</choice>
<choice label="ch17" value="17">Azores</choice>
<choice label="ch18" value="18">Bahamas</choice>
<choice label="ch19" value="19">Bahrain</choice>
<choice label="ch20" value="20">Balearic Islands</choice>
<choice label="ch21" value="21">Bangladesh</choice>
<choice label="ch22" value="22">Barbados</choice>
<choice label="ch23" value="23">Belarus</choice>
<choice label="ch24" value="24">Belgium</choice>
<choice label="ch25" value="25">Belize</choice>
<choice label="ch26" value="26">Benin</choice>
<choice label="ch27" value="27">Bermuda</choice>
<choice label="ch28" value="28">Bhutan</choice>
<choice label="ch29" value="29">Bolivia</choice>
<choice label="ch30" value="30">Bosnia and Herzegovina</choice>
<choice label="ch31" value="31">Botswana</choice>
<choice label="ch32" value="32">Bouvet Island</choice>
<choice label="ch33" value="33">Brazil</choice>
<choice label="ch34" value="34">British Indian Ocean Territory</choice>
<choice label="ch35" value="35">Brunei Darussalam</choice>
<choice label="ch36" value="36">Bulgaria</choice>
<choice label="ch37" value="37">Burkina Faso (formerly Upper Volta)</choice>
<choice label="ch38" value="38">Burma</choice>
<choice label="ch39" value="39">Burundi</choice>
<choice label="ch40" value="40">Cambodia</choice>
<choice label="ch41" value="41">Cameroon</choice>
<choice label="ch42" value="42">Canada</choice>
<choice label="ch43" value="43">Canary Islands</choice>
<choice label="ch44" value="44">Cape Verde</choice>
<choice label="ch45" value="45">Central African Republic</choice>
<choice label="ch46" value="46">Chad</choice>
<choice label="ch47" value="47">Chile</choice>
<choice label="ch48" value="48">China</choice>
<choice label="ch49" value="49">Christmas Island</choice>
<choice label="ch50" value="50">Cocos (Keeling) Islands</choice>
<choice label="ch51" value="51">Colombia</choice>
<choice label="ch52" value="52">Comoros</choice>
<choice label="ch53" value="53">Congo</choice>
<choice label="ch54" value="54">Cook Islands</choice>
<choice label="ch55" value="55">Costa Rica</choice>
<choice label="ch56" value="56">Croatia</choice>
<choice label="ch57" value="57">Cuba</choice>
<choice label="ch58" value="58">Cyprus</choice>
<choice label="ch59" value="59">Czech Republic</choice>
<choice label="ch60" value="60">Denmark</choice>
<choice label="ch61" value="61">Djibouti</choice>
<choice label="ch62" value="62">Dominica</choice>
<choice label="ch63" value="63">Dominican Republic</choice>
<choice label="ch64" value="64">East Timor</choice>
<choice label="ch65" value="65">Ecuador</choice>
<choice label="ch66" value="66">Egypt</choice>
<choice label="ch67" value="67">El Salvador</choice>
<choice label="ch68" value="68">Equatorial Guinea</choice>
<choice label="ch69" value="69">Eritrea</choice>
<choice label="ch70" value="70">Estonia</choice>
<choice label="ch71" value="71">Ethiopia</choice>
<choice label="ch72" value="72">Falkland Islands</choice>
<choice label="ch73" value="73">Faroe Islands</choice>
<choice label="ch74" value="74">Fiji</choice>
<choice label="ch75" value="75">Finland</choice>
<choice label="ch76" value="76">France</choice>
<choice label="ch78" value="78">French Guiana (France)</choice>
<choice label="ch80" value="80">French Polynesia (France)</choice>
<choice label="ch81" value="81">French Southern Territories (France)</choice>
<choice label="ch82" value="82">Gabon</choice>
<choice label="ch83" value="83">Gambia</choice>
<choice label="ch84" value="84">Georgia</choice>
<choice label="ch85" value="85">Germany</choice>
<choice label="ch86" value="86">Ghana</choice>
<choice label="ch87" value="87">Gibraltar</choice>
<choice label="ch88" value="88">Grand Cayman</choice>
<choice label="ch89" value="89">Greece</choice>
<choice label="ch100" value="100">Greenland</choice>
<choice label="ch101" value="101">Grenada</choice>
<choice label="ch102" value="102">Guadeloupe</choice>
<choice label="ch103" value="103">Guam</choice>
<choice label="ch104" value="104">Guatemala</choice>
<choice label="ch105" value="105">Guernsey</choice>
<choice label="ch106" value="106">Guinea</choice>
<choice label="ch107" value="107">Guinea-Bissau</choice>
<choice label="ch108" value="108">Guyana</choice>
<choice label="ch109" value="109">Haiti</choice>
<choice label="ch110" value="110">Heard and McDonald Islands</choice>
<choice label="ch111" value="111">Holy See (Vatican City State)</choice>
<choice label="ch112" value="112">Honduras</choice>
<choice label="ch113" value="113">Hong Kong (see also China)</choice>
<choice label="ch114" value="114">Hungary</choice>
<choice label="ch115" value="115">Iceland</choice>
<choice label="ch116" value="116">India</choice>
<choice label="ch117" value="117">Indonesia</choice>
<choice label="ch118" value="118">Iran</choice>
<choice label="ch119" value="119">Iraq</choice>
<choice label="ch120" value="120">Ireland (includes both Republic of &amp; N. Ireland)</choice>
<choice label="ch121" value="121">Isle of Man</choice>
<choice label="ch122" value="122">Israel</choice>
<choice label="ch123" value="123">Italy</choice>
<choice label="ch124" value="124">Ivory Coast</choice>
<choice label="ch125" value="125">Jamaica</choice>
<choice label="ch126" value="126">Japan</choice>
<choice label="ch127" value="127">Jersey</choice>
<choice label="ch128" value="128">Jordan</choice>
<choice label="ch129" value="129">Kazakhstan</choice>
<choice label="ch130" value="130">Kenya</choice>
<choice label="ch131" value="131">Kiribati</choice>
<choice label="ch132" value="132">Kuwait</choice>
<choice label="ch133" value="133">Kyrgyzstan</choice>
<choice label="ch134" value="134">Laos</choice>
<choice label="ch135" value="135">Latvia</choice>
<choice label="ch136" value="136">Lebanon</choice>
<choice label="ch137" value="137">Lesotho</choice>
<choice label="ch138" value="138">Liberia</choice>
<choice label="ch139" value="139">Libya</choice>
<choice label="ch140" value="140">Liechtenstein</choice>
<choice label="ch141" value="141">Lithuania</choice>
<choice label="ch142" value="142">Luxembourg</choice>
<choice label="ch143" value="143">Macau</choice>
<choice label="ch144" value="144">Macedonia</choice>
<choice label="ch145" value="145">Madagascar</choice>
<choice label="ch146" value="146">Madeira Island</choice>
<choice label="ch147" value="147">Malawi</choice>
<choice label="ch148" value="148">Malaysia</choice>
<choice label="ch149" value="149">Maldives</choice>
<choice label="ch150" value="150">Mali</choice>
<choice label="ch151" value="151">Malta</choice>
<choice label="ch152" value="152">Marshall Islands</choice>
<choice label="ch153" value="153">Martinique</choice>
<choice label="ch154" value="154">Mauritania</choice>
<choice label="ch155" value="155">Mauritius</choice>
<choice label="ch156" value="156">Mayotte</choice>
<choice label="ch157" value="157">Mexico</choice>
<choice label="ch158" value="158">Micronesia</choice>
<choice label="ch159" value="159">Moldova</choice>
<choice label="ch160" value="160">Monaco</choice>
<choice label="ch161" value="161">Mongolia</choice>
<choice label="ch162" value="162">Montserrat</choice>
<choice label="ch163" value="163">Morocco</choice>
<choice label="ch164" value="164">Mozambique</choice>
<choice label="ch165" value="165">Namibia</choice>
<choice label="ch166" value="166">Nauru</choice>
<choice label="ch167" value="167">Nepal</choice>
<choice label="ch168" value="168">Netherlands</choice>
<choice label="ch169" value="169">Netherlands Antilles</choice>
<choice label="ch170" value="170">New Caledonia</choice>
<choice label="ch171" value="171">New Zealand</choice>
<choice label="ch172" value="172">Nicaragua</choice>
<choice label="ch173" value="173">Niger</choice>
<choice label="ch174" value="174">Nigeria</choice>
<choice label="ch175" value="175">Niue</choice>
<choice label="ch176" value="176">Norfolk Island</choice>
<choice label="ch177" value="177">North Korea (see also Korea)</choice>
<choice label="ch178" value="178">Northern Mariana Islands</choice>
<choice label="ch179" value="179">Norway</choice>
<choice label="ch180" value="180">Oman</choice>
<choice label="ch181" value="181">Pakistan</choice>
<choice label="ch182" value="182">Palau</choice>
<choice label="ch183" value="183">Panama</choice>
<choice label="ch184" value="184">Papua New Guinea</choice>
<choice label="ch185" value="185">Paraguay</choice>
<choice label="ch186" value="186">Peru</choice>
<choice label="ch187" value="187">Philippines</choice>
<choice label="ch188" value="188">Pitcairn</choice>
<choice label="ch189" value="189">Poland</choice>
<choice label="ch190" value="190">Portugal</choice>
<choice label="ch191" value="191">Puerto Rico (U.S.)</choice>
<choice label="ch192" value="192">Qatar</choice>
<choice label="ch193" value="193">Republic of South Africa</choice>
<choice label="ch194" value="194">Reunion</choice>
<choice label="ch195" value="195">Romania</choice>
<choice label="ch196" value="196">Russia</choice>
<choice label="ch197" value="197">Rwanda</choice>
<choice label="ch198" value="198">Saint Kitts and Nevis</choice>
<choice label="ch199" value="199">Saint Lucia</choice>
<choice label="ch200" value="200">Saint Vincent and the Grenadines</choice>
<choice label="ch201" value="201">Samoa</choice>
<choice label="ch202" value="202">San Marino</choice>
<choice label="ch203" value="203">Sao Tome and Principe</choice>
<choice label="ch204" value="204">Saudi Arabia</choice>
<choice label="ch205" value="205">Senegal</choice>
<choice label="ch206" value="206">Seychelles</choice>
<choice label="ch207" value="207">Sierra Leone</choice>
<choice label="ch208" value="208">Singapore</choice>
<choice label="ch209" value="209">Slovakia</choice>
<choice label="ch210" value="210">Slovenia</choice>
<choice label="ch211" value="211">Solomon Islands</choice>
<choice label="ch212" value="212">Somalia</choice>
<choice label="ch213" value="213">South Georgia and Sandwich Isl.</choice>
<choice label="ch214" value="214">South Korea (see also Korea)</choice>
<choice label="ch215" value="215">Spain</choice>
<choice label="ch216" value="216">Sri Lanka</choice>
<choice label="ch217" value="217">St. Helena</choice>
<choice label="ch218" value="218">St. Pierre and Miquelon</choice>
<choice label="ch219" value="219">Sudan</choice>
<choice label="ch220" value="220">Surinam</choice>
<choice label="ch221" value="221">Svalbard and Jan Mayen Isl.</choice>
<choice label="ch222" value="222">Swaziland</choice>
<choice label="ch223" value="223">Sweden</choice>
<choice label="ch224" value="224">Switzerland</choice>
<choice label="ch225" value="225">Syria</choice>
<choice label="ch226" value="226">Taiwan</choice>
<choice label="ch227" value="227">Tajikistan</choice>
<choice label="ch228" value="228">Tanzania</choice>
<choice label="ch229" value="229">Thailand</choice>
<choice label="ch230" value="230">Togo</choice>
<choice label="ch231" value="231">Tokelau</choice>
<choice label="ch232" value="232">Tonga</choice>
<choice label="ch233" value="233">Trinidad and Tobago</choice>
<choice label="ch234" value="234">Tunisia</choice>
<choice label="ch235" value="235">Turkey</choice>
<choice label="ch236" value="236">Turkmenistan</choice>
<choice label="ch237" value="237">Turks and Caicos Islands</choice>
<choice label="ch238" value="238">Tuvalu</choice>
<choice label="ch239" value="239">U.S. Minor Outlying Islands</choice>
<choice label="ch240" value="240">Uganda</choice>
<choice label="ch241" value="241">Ukraine</choice>
<choice label="ch242" value="242">United Arab Emirates</choice>
<choice label="ch243" value="243">United Kingdom (see also counties that make up UK)</choice>
<choice label="ch245" value="245">Uruguay</choice>
<choice label="ch246" value="246">Uzbekistan</choice>
<choice label="ch247" value="247">Vanuatu</choice>
<choice label="ch248" value="248">Venezuela</choice>
<choice label="ch249" value="249">Vietnam</choice>
<choice label="ch250" value="250">Virgin Islands (British)</choice>
<choice label="ch251" value="251">Virgin Islands (U.S.)</choice>
<choice label="ch252" value="252">Wallis and Futuna Islands</choice>
<choice label="ch253" value="253">Western Sahara</choice>
<choice label="ch254" value="254">Yemen</choice>
<choice label="ch255" value="255">Yugoslavia</choice>
<choice label="ch256" value="256">Zaire</choice>
<choice label="ch257" value="257">Zambia</choice>
<choice label="ch258" value="258">Zimbabwe</choice>
<choice label="ch259" value="259">Asia/Pacific (excluding Hawaii)</choice>
<choice label="ch260" value="260">Australia or New Zealand</choice>
<choice label="ch261" value="261">Europe</choice>
<choice label="ch262" value="262">Latin America, South America, Mexico</choice>
<choice label="ch263" value="263">Middle East</choice>
<choice label="ch264" value="264">Other Caribbean</choice>
<choice label="ch265" value="265">Africa</choice>
<choice label="ch266" value="266">England (see also United Kingdom)</choice>
<choice label="ch267" value="267">Scotland (see also United Kingdom)</choice>
<choice label="ch268" value="268">Wales (see also UK)</choice>
<choice label="ch269" value="269">Korea (see also North Korea &amp; South Korea)</choice>
<choice label="ch270" value="270">Holland</choice>
<choice label="ch271" value="271">Great Britain</choice>
<choice label="ch272" value="272">Democratic Republic of Congo</choice>
<choice label="ch273" value="273">Cote D'Ivoire</choice>
<choice label="ch274" value="274">Europa Island</choice>
<choice label="ch275" value="275">Glorioso Island</choice>
<choice label="ch276" value="276">Juan De Nova Island</choice>
<choice label="ch277" value="277">Gaza Strip</choice>
<choice label="ch278" value="278">West Bank</choice>
<choice label="ch279" value="279">Midway Island</choice>
<choice label="ch280" value="280">Wake Island</choice>
<choice label="ch281" value="281">Montenegro</choice>
<choice label="ch282" value="282">Serbia</choice>
<choice label="ch283" value="283">Kosovo and metohija</choice>
<choice label="ch284" value="284">Johnston Atoll</choice>
<choice label="ch285" value="285">Northern Ireland (see also UK &amp; Ireland)</choice>
<choice label="ch286" value="286">Ireland (Republic of)</choice>
<choice label="ch994" value="994">Decline To Answer</choice>
<choice label="ch996" value="996">Other Country</choice>
</select>`;

export function generateShell(): string {
  return `
      ${dmGen}
      <suspend/>
      ${dmAge}
      <suspend/>
      ${dmLoc}
      <suspend/>
      
      <term cond="not dmLoc.ch244" markers="dmLoc,qcTerm">Country: Not U.S.</term>
      <suspend/>
      <term cond="dmAge.ival lt 18" markers="dmAge,qcTerm">Age: Under 18</term>
      <suspend/>
    `;
}
